import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SignInProps } from "@/@types";
import { observer } from "mobx-react";

import AuthorizedNavbarMenu from "./AuthorizedNavbarMenu";
import UnauthorizedNavbarMenu from "./UnauthorizedNavbarMenu";
import {
  Typography,
  Stack,
  useTheme,
  SvgIcon,
  Box,
  Avatar,
  Container,
} from "@mui/material";
import { useWeb3Modal } from "@web3modal/react";
import { ReactComponent as Logo } from "@/assets/icons/P2P_Logo.svg";
import { LoadingButton as Button } from "@mui/lab";
import { useAccount } from "wagmi";
import { stringAvatar } from "@/utility";

const Navbar = observer((props: SignInProps) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { open, isOpen } = useWeb3Modal();
  const { address } = useAccount();
  useEffect(() => {
    if (!isOpen && !address && props.userStore.isLogin) {
      navigate("/");
      setTimeout(() => {
        props.userStore.signOut();
      }, 1000);
    }
  }, [isOpen, address]);

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        backdropFilter: "blur(10px)",
      }}
    >
      <Container
        sx={{
          width: "90%",
          maxWidth: props.userStore.isLogin ? "1776px !important" : undefined,
          position: "sticky",
          zIndex: 10,
          top: 0,
          left: 0,
          height: theme.navbarHeight,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          height="100%"
        >
          <Stack
            direction="row"
            gap="10px"
            height="58%"
            alignItems="center"
            onClick={() => {
              navigate("/");
            }}
            sx={{
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            <SvgIcon
              component={Logo}
              sx={{
                height: "100%",
                width: "auto",
                aspectRatio: "1/1",
              }}
              inheritViewBox
            />
            <Typography component="h1" variant="logo">
              Hap p2p
            </Typography>
          </Stack>
          <Stack direction="row" gap="27px">
            {props.userStore.isLogin ? (
              <AuthorizedNavbarMenu />
            ) : (
              <UnauthorizedNavbarMenu />
            )}

            {props.userStore.isLogin && address && (
              <Box
                onClick={() => {
                  open();
                }}
                ml="19px"
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                position="relative"
              >
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    minWidth: "167px",
                    pr: "22px",
                    pl: "44px",
                    boxSizing: "border-box",
                    boxShadow: "none",
                    "&:hover": {
                      boxShadow: "none",
                    },
                  }}
                >
                  {`${address.slice(0, 4)}...${address.slice(-4)}`}
                </Button>
                <Box
                  sx={{
                    height: "100%",
                    position: "absolute",
                    top: "0",
                    left: "0",
                    transform: "translateX(-34.54545454545455%)",
                    aspectRatio: "1/1",
                  }}
                >
                  <Avatar
                    {...stringAvatar(props.userStore.username ?? "", {
                      height: "100%",
                      width: "auto",
                      aspectRatio: "1/1",
                    })}
                  ></Avatar>
                </Box>
              </Box>
            )}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
});

export default Navbar;
